import PropTypes from 'prop-types';
import React, { Component } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as T from "../../redux/constants";
import { radiosComponent } from "../../forms/customInput";
import MailingAddress from "./mailingAddress";
import * as rk from "../../localization/resourceKeys";
import {
  getAddressValidation,
  submitPrivacyRequest,
} from "../../redux/MailingAddressSelector/actions";
import ReCAPTCHA from "react-google-recaptcha";
import { siteKey } from "../../components/ReCaptcha/reCaptcha";
import moment from "moment";
import { getExperianDetails } from "../../redux/ExperianForm/experianAction";
import i18n from "../../i18n";
import { clearErrors } from "../../redux/Errors/actions";
import "./mailingAddressContainer.css";
import BottomLine from "../Footer/BottomLine";
import { Modal } from "../Modal/modal";
import ButtonIntruction from "../buttonInstruction/buttonInstruction";
import { getProtectionServicesExperianDetails } from "../../redux/ProtectionServicesExperianForm/protectionServicesExperianAction";
import { specialPolicyStates, texasLikeStates, utahLikeStates, virginiaLikeStates } from '../../utils/statesUS';

const recaptchaRef = React.createRef();

class GetMailingAddress extends Component {
  constructor(props) {
    super(props);
    if (!props?.selectedRequest) {
      window.location.replace("/");
    }
    this.state = {
      isModalOpen: false,
      radioOptionsValue: "suggestedAddress",
      addressContinue: false,
      captchaEnabled: process.env.REACT_APP_AWS_ENV !== "DEVELOPMENT" && !window.location.origin.includes("localhost"),
      captcha: false,
      deleteRequest: false,
      deleteRequestPayload: {},
      isVerifiedAddressChosen: true,
    };
  }

  getInitialValues () {
    const { experianReducer, t } = this.props;
    const isTXorNE = ["TX", "NE"].includes(this.props.stateSelector?.currentStateResidence);
    const reportTypeLabel = this.isProtectionServices() && isTXorNE ? rk.INFO_FORM.REPORT_SPECIFIC_PIECES : rk.INFO_FORM.REPORT_CATEGORY;

    const initialValues = {
      firstName: `${this.props.secureKey?.givenName || ""}`,
      middleInitial: `${this.props.secureKey?.middleName || ""}`,
      lastName: `${this.props.secureKey?.familyName|| ""}`,
      dateOfBirth: `${this.props.secureKey?.birthDate|| ""}`,
      phone: "",
      emailAddress: "",
      reEnterEmailAddress: "",
      ssn: "",
      vin: "",
      reportType: t(reportTypeLabel),
      reportTypeLabel,
      requestType: this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO),
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      postalCode: "",
      reportCheck: true,
    };

    // Set retry values when user wants to retry experian request.
    if(experianReducer?.submitPrivacyRequestPayload?.requester) {
      const { requestType, requester } = experianReducer.submitPrivacyRequestPayload;
      initialValues.firstName = requester.firstName;
      initialValues.middleInitial = requester.middleName;
      initialValues.lastName = requester.lastName;
      initialValues.dateOfBirth = requester.dateOfBirth;
      initialValues.phone = requester.phone;
      initialValues.emailAddress = requester.emailAddress;
      initialValues.reEnterEmailAddress = requester.emailAddress;
      initialValues.ssn = requester.fullSsn;
      initialValues.vin = requester.vin;
      initialValues.reportType = requestType === "TIER2_RPT"? t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES) : t(rk.INFO_FORM.REPORT_CATEGORY);
      initialValues.requestType = this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO);
      initialValues.addressLine1 = requester.addresses[0].addressLine1;
      initialValues.addressLine2 = this.props.mailingAddress.addressLine2;
      initialValues.city = requester.addresses[0].city;
      initialValues.state = requester.addresses[0].stateOrProvince;
      initialValues.postalCode = requester.addresses[0].postalCode;
      initialValues.reportCheck = true;
    }

    return initialValues;
  };

  componentDidMount(){
    this.props.clearErrors();
  }

  // This function was created to assist in validating the Date of Birth field because of issues run into when testing in older
  // browsers (IE11 and Safari, specifically). The issue is that older browsers do not recognize HTML inputs of type="date" which is
  // what is being used for this field. In browsers that do not recognize this HTML input, the value returned is a string. In browsers
  // that do recognize the HTML input, the value is returned in a date format based on ISO8601 (YYYY-MM-DD). This function checks for
  // the presence of "/" to determine which format and then validates based on that.
  birthDateValidation(inputValue, minBirthDate, maxBirthDate) {
    let returnValue = false;
    let dateObject = null;

    //this date format is a string of "MM/DD/YYYY" - validate with that format in mind. Note: the "L" here is MomentJs shorthand for "MM/DD/YYYY"
    dateObject = moment(inputValue, "L", true);
    if (dateObject > new Date()) {
      return returnValue;
    } else {
      //when min & max are passed, validate validity and min/max restrictions. Otherwise just validity
      returnValue =
        minBirthDate && maxBirthDate
          ? dateObject.isValid() &&
            moment(dateObject).isSameOrAfter(minBirthDate) &&
            moment(dateObject).isSameOrBefore(maxBirthDate)
          : dateObject.isValid();
    }

    return returnValue;
  }

  isDeleteMyInfoQC = () => {
    const country = this.props?.country;
    const currentStateResidence =
      this.props?.stateSelector?.currentStateResidence;

    return (
      country.toLowerCase() === "canada" &&
      currentStateResidence === "QC" &&
      this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO)
    );
  };

  isDeleteMyInfoVALikeorUTLike = () => {
    const { currentStateResidence } = this.props?.stateSelector ?? {};
    const isDeleteRequest = this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO);
    const statesAllowingDeletion = [
      ...virginiaLikeStates,
      ...utahLikeStates,
    ];
    
  
    return isDeleteRequest && statesAllowingDeletion.includes(currentStateResidence);
  };

  isDeleteMyInfoSpecialPolicyState = () => {
    const { currentStateResidence } = this.props?.stateSelector || {};
    const deleteInfoRequest = i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO);
    
    return (
      specialPolicyStates.includes(currentStateResidence) &&
      this.props.selectedRequest === deleteInfoRequest
    );
  };

  isProtectionServices = () => {
    return (
      this.props?.stateSelector?.brandAffiliation ===
      i18n.t(rk.BRANDS_OPTION_VWD_APP_DER)
    );
  };

  isDNSRequest = () => {
    return this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO);
  };

  requiredAddress = () => {
    const isVWGoA = this.props?.stateSelector?.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VWFS_DFS_AFS) || this.props?.stateSelector?.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VW_AUDI);
    const isDNSRequest = this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO);
    const isBehalfSelf = this.props?.stateSelector?.submissionOnBehalfOf === i18n.t(rk.ON_BEHALF_OPTION_SELF);
    const isBehalfAgent = this.props?.stateSelector?.submissionOnBehalfOf === i18n.t(rk.ON_BEHALF_OPTION_OTHER_CA);

    return !(isDNSRequest && isVWGoA && (isBehalfSelf || isBehalfAgent));
  }

  onChange = () => {
    this.setState({
      captcha: true,
    });
  };

  changeAddressVerified = () => {
    this.setState({
      isVerifiedAddressChosen: true,
    });
  };

  changeAddressNotVerified = () => {
    this.setState({
      isVerifiedAddressChosen: false,
    });
  };

  onSubmit = () => {
    const recaptchaValue = recaptchaRef.current.getValue();
    this.props.onSubmit(recaptchaValue);
  };

  validate() {
    const { t } = this.props;
    const minBirthDate = moment("0001-01-01");
    const maxBirthDate = moment(new Date()).add(-18, "years");
    const isQC = this.props?.stateSelector?.currentStateResidence === "QC";
    const requiredAddress = this.requiredAddress();
    
    let returnValue = Yup.object().shape({
      phone: Yup.string()
        .matches(/^\d*$/, {
          message: t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR),
        })
        .min(10, t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
        .max(10, t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR))
        .when([], {
          is: () => requiredAddress,
          then: (schema) => schema.required(t(rk.CCPA_FORM_ERROR.PHONE_NUMBER_ERROR)),
          otherwise: (schema) => schema.notRequired(),
        }),
      vin: Yup.string()
        .min(17, t(rk.CCPA_FORM_ERROR.VIN_NUMBER_ERROR))
        .max(17, t(rk.CCPA_FORM_ERROR.VIN_NUMBER_ERROR)),
      state: Yup.string()
        .when([], {
          is: () => requiredAddress,
          then: (schema) => schema.required(t(rk.CCPA_FORM_ERROR.STATE_ERROR)),
          otherwise: (schema) => schema.notRequired(),
        }),
      reportCheck: Yup.bool(),
      isVerifiedAddressChosen: Yup.bool(),
    });

    // The validation of postal code depends of the country
    const validationUS = /^\d{5}(?:-\d{4})?$/;
    const validationCA = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;

    const isCanada = this.props.country.toLowerCase() === "canada";

    const postalCodeValidation = isCanada ? validationCA : validationUS;
    const postalCodeLength = isCanada ? 7 : 5;

    returnValue = returnValue.concat(
      Yup.object().shape({
        postalCode: Yup.string()
          .matches(postalCodeValidation, t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR))
          .max(postalCodeLength, t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR))
          .when([], {
            is: () => requiredAddress,
            then: (schema) => schema.required(t(rk.CCPA_FORM_ERROR.ZIP_CODE_ERROR)),
            otherwise: (schema) => schema.notRequired(),
          }),
      })
    );

    const USRegex = /^[a-zA-Z '-]*$/;
    const canadaRegex = /^[A-Za-z0-9'&,ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ. _-]*$/;
    const addressRegex = /^[#&'"!.0-9a-zA-Z\s,-]*$/;
    const canadaEmailRegex = /^[A-Za-z0-9'&,ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ@._-]{0,50}$/;

    const addressLine1Field = (regex) =>
      Yup.string()
        .matches(regex, { message: t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR) })
        .max(80, t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR))
        .when([], {
          is: () => requiredAddress,
          then: (schema) => schema.required(t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR)),
          otherwise: (schema) => schema.notRequired(),
        });
    
    const addressLine2Field = (regex) =>
      Yup.string()
        .matches(regex, { message: t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR) })
        .max(80, t(rk.CCPA_FORM_ERROR.ADDRESS_LINE_ERROR));
    
    const firstNameField = (regex) =>
      Yup.string()
        .required(
          t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR, {
            fieldName: "First Name",
          })
        )
        .matches(regex, { message: t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR) })
        .max(40, t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR));
    
    const middleNameField = (regex) =>
      Yup.string()
        .matches(regex, { message: t(rk.CCPA_FORM_ERROR.MIDDLE_NAME_ERROR) })
        .max(
          1,
          t(rk.CCPA_FORM_ERROR.MIDDLE_NAME_ERROR, {
            fieldName: "Middile Initial",
          })
        );
    
    const lastNameField = (regex) =>
      Yup.string()
        .required(
          t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR, {
            fieldName: "Last Name",
          })
        )
        .matches(regex, { message: t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR) })
        .max(40, t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR));

    const emailField = () =>
      Yup.string()
        .required(t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR))
        .email(t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR))
        .max(50, t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR))
        .when([], {
          is: () => isCanada,
          then: (schema) => schema.matches(
            canadaEmailRegex,
            { message: t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR) }
          )
        });
    
    const reEnterEmailField = (regex) =>
      Yup.string()
        .required(t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .email(t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .max(50, t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .oneOf([Yup.ref("emailAddress")], t(rk.EMAIL_DONT_MATCH))
        .when([], {
          is: () => isCanada,
          then: (schema) => schema.matches(
            canadaEmailRegex,
            { message: t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR) }
          )
        });
    
    const cityField = (regex) =>
      Yup.string()
        .matches(
          regex,
          { message: t(rk.CCPA_FORM_ERROR.CITY_ERROR) }
        )
        .max(40, t(rk.CCPA_FORM_ERROR.CITY_ERROR))
        .when([], {
          is: () => requiredAddress,
          then: (schema) => schema.required(t(rk.CCPA_FORM_ERROR.CITY_ERROR)),
          otherwise: (schema) => schema.notRequired(),
        });

    if (isCanada) {
      returnValue = returnValue.concat(
        Yup.object().shape({
          firstName: firstNameField(canadaRegex),
          middleInitial: middleNameField(/^[A-Za-z ÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖàáâäçèéêëìíîïòóôöùúûüÙÚÛÜñÑ]$/),
          lastName: lastNameField(canadaRegex),
          emailAddress: emailField(),
          reEnterEmailAddress: reEnterEmailField(),
          addressLine1: addressLine1Field(canadaRegex),
          addressLine2: addressLine2Field(canadaRegex),
          city: cityField(canadaRegex),
        })
      );
    } else {
      returnValue = returnValue.concat(
        Yup.object().shape({
          firstName: firstNameField(USRegex),
          middleInitial: middleNameField(/^[a-zA-Z]*$/),
          lastName: lastNameField(USRegex),
          emailAddress: emailField(),
          reEnterEmailAddress: reEnterEmailField(),
          addressLine1: addressLine1Field(addressRegex),
          addressLine2:  addressLine2Field(addressRegex),
          city: cityField(USRegex),
        })
      );
    }

    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)) {
      returnValue = returnValue.concat(
        Yup.object().shape({
          isCorrectMyInfo: Yup.boolean().default(true),
        })
      );
    }


    if (this.isProtectionServices()) {
      returnValue = returnValue.concat(
        Yup.object().shape({
          vin: Yup.string()
            .required(t(rk.CCPA_FORM_ERROR.VIN_NUMBER_ERROR))
            .min(17, t(rk.CCPA_FORM_ERROR.VIN_NUMBER_ERROR))
            .max(17, t(rk.CCPA_FORM_ERROR.VIN_NUMBER_ERROR)),
          isProtectionServices: Yup.boolean().default(true),
        })
      );
    }
    if (this.isProtectionServices() && (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO) || this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA))) {
      returnValue = returnValue.concat(
        Yup.object().shape({
          dateOfBirth: Yup.string()
            .required(t(rk.CCPA_FORM_ERROR.DOB_ERROR))
            .test("dateOfBirth", t(rk.INFO_FORM.DATE_REQUIRED), (value) => {
              return this.birthDateValidation(value);
            })
            .test(
              "dateOfBirth",
              t(rk.INFO_FORM.DATE_AGE_RESTRICTION),
              (value) => {
                return this.birthDateValidation(
                  value,
                  minBirthDate,
                  maxBirthDate
                );
              }
            ),
        })
      );
    } else if (
        !(
          this.props.selectedRequest ===
            t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO) ||
          this.isDeleteMyInfoVALikeorUTLike(t)
        ) &&
        !(this.isProtectionServices() && this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DELETE_INFO))
      ) {
        returnValue = returnValue.concat(
          Yup.object().shape({
            dateOfBirth: Yup.string()
              .required(t(rk.CCPA_FORM_ERROR.DOB_ERROR))
              .test("dateOfBirth", t(rk.INFO_FORM.DATE_REQUIRED), (value) => {
                return this.birthDateValidation(value);
              })
              .test(
                "dateOfBirth",
                t(rk.INFO_FORM.DATE_AGE_RESTRICTION),
                (value) => {
                  return this.birthDateValidation(
                    value,
                    minBirthDate,
                    maxBirthDate
                  );
                }
              ),
          })
        );
      }

      if (this.isProtectionServices() && (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO) || this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA))) {
        returnValue = returnValue.concat(
          Yup.object().shape({
            ssn: Yup.string()
            .required(t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR))
            .matches(/^\d*$/, {
              message: t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR),
            })
            .min(9, t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR))
            .max(9, t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR)),
          })
        );
      } else if (
        !(
          this.props.selectedRequest ===
            t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO) ||
          this.isDeleteMyInfoVALikeorUTLike(t)
        ) &&
        !isQC &&
        !(this.isProtectionServices() && this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DELETE_INFO))
      ) {
        returnValue = returnValue.concat(
          Yup.object().shape({
            ssn: Yup.string().when(['reportType', 'isCorrectMyInfo'], {
              is: (reportType, isCorrectMyInfo) => {
                if (reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES) || isCorrectMyInfo) {
                  return true;
                }
              },
              then: Yup.string()
                .required(t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR))
                .matches(/^\d*$/, { message: t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR) })
                .min(9, t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR))
                .max(9, t(rk.CCPA_FORM_ERROR.FULL_SSN_ERROR)),
              otherwise: Yup.string()
                .required(t(rk.CCPA_FORM_ERROR.LAST4_SSN_ERROR))
                .matches(/^\d*$/, { message: t(rk.CCPA_FORM_ERROR.LAST4_SSN_ERROR) })
                .min(4, t(rk.CCPA_FORM_ERROR.LAST4_SSN_ERROR))
                .max(4, t(rk.CCPA_FORM_ERROR.LAST4_SSN_ERROR)),
            })
          })
        );
      }

    // this case needed to be added to make sure user couldn't skip the Address info
    //  without selection a report type when the option appeared
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO)) {
      returnValue = returnValue.concat(
        Yup.object().shape({
          reportType: Yup.string()
            .min(1, t(rk.ERROR_REQUIRED))
            .required(t(rk.ERROR_REQUIRED)),
        })
      );
    } else {
      returnValue = returnValue.concat(
        Yup.object().shape({
          reportType: Yup.string(),
        })
      );
    }

    return returnValue;
  }

  onCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  updateRadioOptionsValue(value) {
    this.setState({
      radioOptionsValue: value,
    });
  }

  getSuggestedAddress() {
    const { t } = this.props;

    return (
      <>
        {t(rk.MAILING_ADDRESS.SUGGESTED_ADDRESS)} <br />
        <b>
          {this.props.suggestedMailingAddress.addressLine1},{" "}
          {this.props.suggestedMailingAddress.city},{" "}
          {this.props.suggestedMailingAddress.state},{" "}
          {this.props.suggestedMailingAddress.postalCode}
        </b>
      </>
    );
  }

  getEnteredAddress(values) {
    const { t } = this.props;
    return (
      <>
        {t(rk.MAILING_ADDRESS.USE_ENTERED_ADDRESS)}
        <br />
        {values.addressLine1}
        {values.addressLine2 ? `, ${values.addressLine2}` : ''}
        , {values.city}, {values.state}, {values.postalCode}
      </>
    );
  }

  getModalContent(values, isBadRequest) {
    const { t } = this.props;
    return (
      <div>
        {isBadRequest ? (
          <>
            <p id="strikeitron-error-p">{t(rk.ERROR_STRIKEIRON)}</p>
            <Field
              name="reEnterAddress"
              data-testid="reEnterAddress"
              id="reEnteredAddress"
              radioText={t(rk.MAILING_ADDRESS.REENTER_ADDRESS)}
              onClick={() => {
                this.updateRadioOptionsValue("reEnterAddress");
              }}
              isChecked={this.state.radioOptionsValue === "reEnterAddress"}
              component={radiosComponent}
            />
          </>
        ) : (
          <>
            <p id="strikeitron-error-p">{t(rk.MAILING_ADDRESS.MODAL_TITLE)}</p>
            <Field
              name="suggestedAddress"
              data-testid="suggestedAddress"
              id="suggestedAddress"
              radioText={this.getSuggestedAddress()}
              onClick={() => {
                this.changeAddressVerified();
                this.updateRadioOptionsValue("suggestedAddress");
              }}
              isChecked={this.state.radioOptionsValue === "suggestedAddress"}
              component={radiosComponent}
            />
          </>
        )}

        <Field
          name="enteredAddress"
          data-testid="enteredAddress"
          id="enteredAddress"
          radioText={this.getEnteredAddress(values)}
          onClick={() => {
            this.changeAddressNotVerified();
            this.updateRadioOptionsValue("enteredAddress");
          }}
          isChecked={this.state.radioOptionsValue === "enteredAddress"}
          component={radiosComponent}
        />
      </div>
    );
  }

  getModalFooter(values, setValues, resetForm) {
    const { t } = this.props;
    return (
      <div id="continue-button" className="state-btn">
        <button
          className="c-btn"
          onClick={() => this.onContinue(values, setValues, resetForm)}
          disabled={this.state.radioOptionsValue === ""}
          data-testid="continue-btn"
        >
          <span className="c-btn__text">{t(rk.BUTTON.CONTINUE)}</span>
        </button>
      </div>
    );
  }

  onContinue = (values, setValues, resetForm) => {
    const currentStateResidence = this.props.stateSelector.currentStateResidence;
    const isQC = currentStateResidence === i18n.t(rk.STATE_QUEBEC);

    if (this.state.radioOptionsValue === "reEnterAddress") {
      resetForm({
        firstName: isQC ? this.props.secureKey?.givenName : "",
        middleInitial: isQC ? this.props.secureKey?.middleName : "",
        lastName: isQC ? this.props.secureKey?.familyName : "",
        phone: "",
        emailAddress: "",
        reEnterEmailAddress: "",
        ssn: "",
        vin: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        reportCheck: true,
      });
      this.onCloseModal();
    } else {
      this.setState({ isModalOpen: false }, () => {
        if (this.state.radioOptionsValue === "enteredAddress") {
          this.props.updateMailingAddress(values);
        } else {
          const updatedValues = {
            ...values,
            addressLine1:
              this.props.suggestedMailingAddress.addressLine1.trim(),
            addressLine2: "",
            city: this.props.suggestedMailingAddress.city.trim(),
            state: this.props.suggestedMailingAddress.state,
            postalCode: this.props.suggestedMailingAddress.postalCode,
          };
          setValues(updatedValues);
        }

        this.submitAddress(values);
      });
    }
  };

  handleBlur = () => {
    this.setState({
      addressContinue: false,
    });
  };

  modalOpen = () => {
    this.setState({
      isModalOpen: true,
      radioOptionsValue:
        !this.props.suggestedMailingAddress.isAddressFound
          ? "reEnterAddress"
          : "suggestedAddress",
    });
  };

  submitAddress = (values) => {
    const { t } = this.props;
    const stateOfResidence =
      this.props.stateSelector?.currentStateResidence || "Other";
    const isProtectionServices = this.isProtectionServices();
    const isCanada = this.props.initialReducer?.country?.toLowerCase() === "canada";
    const requiredAddress = this.requiredAddress();
    const allAddressFieldsEmpty = !values.addressLine1 && !values.addressLine2 && !values.city && !values.state && !values.postalCode;

    const submitPrivacyRequestPayload = {
      requestType: this.getRequestType(),
      requestorType: this.getRequestorType(),
      requester: {
        stateOfResidence: stateOfResidence,
        firstName: this.props.info.firstName.trim(),
        middleName: this.props.info.middleInitial,
        pin: "",
        lastName: this.props.info.lastName.trim(),
        dateOfBirth: this.props.info.dateOfBirth
          ? moment(this.props.info.dateOfBirth).format("MM/DD/YYYY")
          : "",
        last4Ssn: (() => {
          if (this.props.info.ssn.length === 4) {
            return this.props.info.ssn;
          } else if (this.props.info.ssn.length === 9) {
            return this.props.info.ssn.slice(5, 9);
          }
          return "";
        })(),
        fullSsn: this.props.info.ssn.length === 9 ? this.props.info.ssn : "",
        phone: this.props.info.phone,
        emailAddress: this.props.info.emailAddress,
        vin: this.props.info.vin,
        addresses: !requiredAddress && allAddressFieldsEmpty ? [] : [
          {
            addressLine1:
              this.state.radioOptionsValue === "enteredAddress"
                ? values.addressLine1.trim()
                : this.props.suggestedMailingAddress.addressLine1,
            addressLine2:
              this.state.radioOptionsValue === "enteredAddress"
                ? values.addressLine2.trim()
                : this.props.suggestedMailingAddress.addressLine2,
            city:
              this.state.radioOptionsValue === "enteredAddress"
                ? values.city.trim()
                : this.props.suggestedMailingAddress.city,
            stateOrProvince:
              this.state.radioOptionsValue === "enteredAddress"
                ? values.state
                : this.props.suggestedMailingAddress.state,
            postalCode:
              this.state.radioOptionsValue === "enteredAddress"
                ? values.postalCode
                : this.props.suggestedMailingAddress.postalCode,
            postalCodeExtension: "",
            addressType: "RQST-MAIL",
          },
        ],
      },
      brands: {
        isVw: (this.props.stateSelector.brandAffiliation)?.indexOf("Volkswagen") !== -1,
        isAudi: (this.props.stateSelector.brandAffiliation)?.indexOf("Audi") !== -1,
        isBugatti: (this.props.stateSelector.brandAffiliation)?.indexOf("Bugatti") !== -1,
        isBentley: this.props.stateSelector.bentleyCustomer === i18n.t(rk.BENTLEY_CUSTOMER_OPTION_BENTLEY) || (this.props.stateSelector.brandAffiliation)?.indexOf(i18n.t(rk.BENTLEY_CUSTOMER_OPTION_BENTLEY))!== -1,
        isLamborghini: (this.props.stateSelector.brandAffiliation)?.indexOf("Lamborghini") !== -1,
        isVwc: (this.props.stateSelector.brandAffiliation)?.indexOf("Volkswagen Credit") !== -1,
        isAfs: (this.props.stateSelector.brandAffiliation)?.indexOf("Audi Financial Services") !== -1,
        isDfs: (this.props.stateSelector.brandAffiliation)?.indexOf("Ducati Financial") !== -1
      },
      source: "Privacy_Portal",
      isSnailMail: !values.reportCheck,
      isVerifiedAddressChosen: this.state.isVerifiedAddressChosen,
      requestDate: new Date().toISOString(),
      isProtectionServices,
      isAgentSubmission:  this.props.stateSelector.isAgentSubmission,
      agent: this.props.stateSelector.agentInfo
    };

    if (isCanada) {
      submitPrivacyRequestPayload.vgoaRequestInd = false;
      submitPrivacyRequestPayload.isCanadaInd = true;
      submitPrivacyRequestPayload.languageCode =
        this.props?.initialReducer?.language;
      submitPrivacyRequestPayload.canadaVerification = {
        secureKeyId: this.props.secureKey?.comSecurekeyVerifiedMeLicenseId || this.props.secureKey?.comSecurekeyVidsJobId || "",
      };
    }

    const experianPayload = {
      firstName: this.props.info.firstName.trim(),
      middleName: this.props.info.middleInitial,
      lastName: this.props.info.lastName.trim(),
      addressLine1: values.addressLine1.trim(),
      addressLine2: values.addressLine2.trim(),
      city: values.city.trim(),
      stateOrProvince: values.state,
      postalCode: values.postalCode,
      postalCodeExtension: "",
      dateOfBirth: moment(this.props.info.dateOfBirth).format("MM/DD/YYYY"),
      fullSsn: this.props.info.ssn.length === 9 ? this.props.info.ssn : "",
      telephoneNumber: this.props.info.phone,
    };

    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO)) {
      if (isProtectionServices) {
        this.props.getProtectionServicesExperianDetails(
          experianPayload,
          this.props.history,
          submitPrivacyRequestPayload
        );
      } else if (
        this.props.info.reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES) && !isCanada
      ) {
        this.props.getExperianDetails(
          experianPayload,
          this.props.history,
          submitPrivacyRequestPayload
        );
      } else {
        this.props.submitPrivacyRequest(
          submitPrivacyRequestPayload,
          this.routeOnSubmit,
          this.props
        );
      }
    } else if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DELETE_INFO)) {
      this.props.history.push("/deletePreConfirm", {
        deleteRequestPayload: submitPrivacyRequestPayload,
      });
    } else if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)
    ) {
      this.props.history.push("/dataCorrectionForm", {
        submitPrivacyRequestPayload: submitPrivacyRequestPayload,
      });
    } else if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.LIMIT_DATA)
    ) {
      this.props.history.push("/formComplete", {
        isLimitDataFormComplete: true,
      });
    } else {
      this.props.submitPrivacyRequest(
        submitPrivacyRequestPayload,
        this.routeOnSubmit,
        this.props
      );
    }
  };

  handleAddressValidation = (values) => {
    const equalAddress =
      this.props.suggestedMailingAddress.isAddressFound &&
      values.addressLine1.toLowerCase() === this.props.suggestedMailingAddress.addressLine1.toLowerCase() &&
      values.city.toLowerCase() === this.props.suggestedMailingAddress.city.toLowerCase() &&
      values.state.toLowerCase() === this.props.suggestedMailingAddress.state.toLowerCase() &&
      values.postalCode.toLowerCase() === this.props.suggestedMailingAddress.postalCode.toLowerCase();
    // If the addresses are the same, we don't show the modal
    if (equalAddress) {
      this.submitAddress(values);
    } else {
      this.modalOpen();
    }
  };

  getRequestType = () => {
    const { t } = this.props;
    const reportType = t(this.props.info.reportTypeLabel);
    let requestType;
    if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO)
    ) {
      requestType = "DO_NOT_SELL";
    }
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DO_NOT_USE_INFO)) {
      requestType = "DO_NOT_USE";
    }
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.DELETE_INFO)) {
      requestType = "DELETE";
    }
    if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO) &&
      reportType === t(rk.INFO_FORM.REPORT_CATEGORY)
    ) {
      const isTXandPS = this.isProtectionServices() && (texasLikeStates.includes(this.props.stateSelector?.currentStateResidence));
      requestType =  isTXandPS ? "TIER2_RPT" : "TIER1_RPT";
    }
    if (
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO) &&
      reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
    ) {
      requestType = "TIER2_RPT";
    }
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA)) {
      requestType = "CORRECT_DATA";
    }
    if (this.props.selectedRequest === t(rk.REQUEST_SELECTOR.LIMIT_DATA)) {
      requestType = "LIMIT_DATA";
    }
    return requestType;
  };

  getRequestorType = () => {
    let requestorType = "Consumer";
    const customerRelation = this.props.stateSelector?.customerRelation ?? "";
    if (customerRelation === i18n.t(rk.QUESTION_2_OPTION_1))
      requestorType = "Consumer";
    if (customerRelation === i18n.t(rk.QUESTION_2_OPTION_2))
      requestorType = "Personnel";
    if (customerRelation === i18n.t(rk.QUESTION_2_OPTION_3))
      requestorType = "Business_Contact";

    return requestorType;
  };

  routeOnSubmit = () => {
    const requestType = this.getRequestType();
    if (requestType === "DO_NOT_SELL") {
      this.props.history.push("/formComplete", { isDNSFormComplete: true });
    }

    if (requestType === "DO_NOT_USE") {
      this.props.history.push("/formComplete", { isDNUFormComplete: true });
    }

    if (requestType === "TIER1_RPT") {
      this.props.history.push("/formComplete", { isTier1FormComplete: true });
    }

    if (requestType === "TIER2_RPT") {
      this.props.history.push("/formComplete", { isTier2FormComplete: true });
    }
  };

  getButtonDisable = (
    values,
    isDeleteMyInfoVALikeOrUTLike,
    isDeleteMyInfoSpecialPolicyState,
    showSSN
  ) => {
    const isProtectionServices = this.isProtectionServices();
    const getCaptchaStatus = () => {
      return !this.state.captchaEnabled || this.state.captcha;
    };
    const isCaptchaEnabled = getCaptchaStatus();
    const requiredAddress = this.requiredAddress();
    const requiredValues = values.city &&
      values.state &&
      values.postalCode &&
      values.phone &&
      values.addressLine1;

    return !(
      values.firstName &&
      values.lastName &&
      values.emailAddress &&
      values.reEnterEmailAddress &&
      (requiredAddress ? requiredValues : true) &&
      (!(
        this.isDNSRequest() ||
        isDeleteMyInfoVALikeOrUTLike ||
        (isDeleteMyInfoSpecialPolicyState && isProtectionServices)
      )
        ? values.dateOfBirth
        : true) &&
      (showSSN ? values.ssn : true) &&
      (isProtectionServices? values.vin : true) &&
      isCaptchaEnabled
    );
  };

  render() {
    const { t } = this.props;
    const showElectronicReport =
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO);
    const showReportOptions =
      this.props.selectedRequest === t(rk.REQUEST_SELECTOR.ACCESS_INFO);
    const isAccessMyInfo =
      this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.KNOW_INFO);
    const isKnowMyInfo = this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO)
    const isCorrectMyInfo =
      this.props.selectedRequest ===
      i18n.t(rk.REQUEST_SELECTOR.CORRECT_MY_DATA);
    const isDeleteMyInfoQC = this.isDeleteMyInfoQC();
    const isDeleteMyInfoVALikeOrUTLike = this.isDeleteMyInfoVALikeorUTLike();
    const isDeleteMyInfoSpecialPolicyState = this.isDeleteMyInfoSpecialPolicyState();
    const isProtectionServices = this.isProtectionServices();
    const currentStateResidence =
      this.props.stateSelector.currentStateResidence;
    const isQC = currentStateResidence === i18n.t(rk.STATE_QUEBEC);
    const isCA = currentStateResidence === i18n.t(rk.STATE_CALIFORNIA);
    const showSSN =
      !(this.isDNSRequest() || isDeleteMyInfoVALikeOrUTLike) &&
      !isQC &&
      !(isDeleteMyInfoSpecialPolicyState && isProtectionServices);
    const initialValues = this.getInitialValues();
    return (
      <>
        <Formik
          initialValues={initialValues}
          onSubmit={async (values, { setSubmitting }) => {
            await this.props.clearErrors();
            this.props.submitInfo(values);
            const requiredAddress = this.requiredAddress();
            const allAddressFieldsEmpty = !values.addressLine1 && !values.addressLine2 && !values.city && !values.state && !values.postalCode;

            if (!requiredAddress && allAddressFieldsEmpty) {
              this.submitAddress(values);
              setSubmitting(false);
              return;
            }

            const addressValidationPayload = {
              addressLine1: values.addressLine1,
              addressLine2: values.addressLine2,
              city: values.city,
              state: values.state,
              postalCode: values.postalCode,
              reportCheck: values.reportCheck,
              country: this.props.country.toLowerCase() === "canada" ? "CANADA" : "USA"
            };

            this.props.getAddressValidation(
              addressValidationPayload,
              this.handleAddressValidation,
              this.props
            );

            setSubmitting(false);
          }}
          validationSchema={this.validate()}
        >
          {(props) => {
            const { values, handleSubmit, setValues, resetForm } = props;
                     
            const isBadRequest = !this.props.suggestedMailingAddress.isAddressFound;
            return (
              <>
                <div className="o-layout u-m-none">
                  <div className="o-layout__item u-1/1 u-p-none">
                    <MailingAddress
                      showElectronicReport={showElectronicReport}
                      showReportOptions={showReportOptions}
                      isAccessMyInfo={isAccessMyInfo}
                      isKnowMyInfo={isKnowMyInfo}
                      isDNS={this.isDNSRequest()}
                      isCorrectMyInfo={isCorrectMyInfo}
                      isDeleteMyInfoQC={isDeleteMyInfoQC}
                      isDeleteMyInfoVALikeOrUTLike={
                        isDeleteMyInfoVALikeOrUTLike
                      }
                      isDeleteMyInfoSpecialPolicyState={isDeleteMyInfoSpecialPolicyState}
                      isProtectionServices={isProtectionServices}
                      handleFieldBlur={(e) => this.handleBlur(e)}
                      mailingAddress={this.props.mailingAddress}
                      country={this.props.initialReducer?.country}
                      history={this.props.history}
                      {...props}
                      networkError={this.props.networkError}
                      initialValues={initialValues}
                    />
                  </div>
                </div>
                {this.state.captchaEnabled === true && (
                  <div className="u-m-none">
                    <div className="u-1/1 center-div">
                      <form onSubmit={this.onSubmit}>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={siteKey}
                          onChange={this.onChange}
                          hl={
                            this.props.initialReducer?.language?.toUpperCase() ===
                            "FRA"
                              ? "fr"
                              : "en"
                          }
                          key={
                            this.props.initialReducer?.language?.toUpperCase() ===
                            "FRA"
                              ? "fr"
                              : "en"
                          }
                        />
                      </form>
                    </div>
                  </div>
                )}

                {isCorrectMyInfo && !isCA && !isQC && (
                  <div className="o-layout__item u-1/1 u-mt-xsmall personal-info header-text-fs u-p-none@s u-p-none@xs">
                    {t(rk.INFO_FORM.NOTE_3)}
                  </div>
                )}
                {isDeleteMyInfoQC === false && (
                  <div className="o-layout u-m-none">
                    <div className="o-layout__item u-1/1 u-mt-small">
                      <button
                        className="c-btn u-block u-block-center"
                        onClick={handleSubmit}
                        data-testid="mailing-address-form-btn"
                        disabled={this.getButtonDisable(
                          values,
                          isDeleteMyInfoVALikeOrUTLike,
                          isDeleteMyInfoSpecialPolicyState,
                          showSSN
                        )}
                      >
                        <span className="c-btn__text">
                          {t(rk.BUTTON.SUBMIT)}
                        </span>
                      </button>
                    </div>
                  </div>
                )}

                {isCorrectMyInfo && !isCA && !isQC && (
                  <>
                    <ButtonIntruction
                      link="https://www.vwcredit.com/login"
                      buttonText={t(rk.DATA_CORRECTION.VCI.CUSTOMER_CTA_2)}
                      instructionTitle={t(
                        rk.DATA_CORRECTION.MY_VW_INSTRUCTION_TITLE
                      )}
                      instructions={
                        <ul className="o-list-casual">
                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_VW_INTRUCTION.ONE)}
                          </li>

                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_VW_INTRUCTION.TWO)}
                          </li>

                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_VW_INTRUCTION.THREE)}
                          </li>
                        </ul>
                      }
                    />

                    <div className="block-divider">
                      <hr className="block-horizontal-rule u-mb-none" />
                    </div>

                    <ButtonIntruction
                      link="https://www.audiusa.com/myaudi"
                      buttonText={t(rk.DATA_CORRECTION.VCI.CUSTOMER_CTA_1)}
                      instructionTitle={t(
                        rk.DATA_CORRECTION.MY_AUDI_INTRUCTION_TITLE
                      )}
                      instructions={
                        <ul className="o-list-casual">
                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_AUDI_INTRUCTION.ONE)}
                          </li>

                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_VW_INTRUCTION.TWO)}
                          </li>

                          <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                            {t(rk.DATA_CORRECTION.MY_VW_INTRUCTION.THREE)}
                          </li>
                        </ul>
                      }
                    />
                  </>
                )}
                <Modal
                  bodyContent={this.getModalContent(values, isBadRequest)}
                  closeModal={this.onCloseModal}
                  footerContent={this.getModalFooter(
                    values,
                    setValues,
                    resetForm
                  )}
                  isModalOpen={this.state.isModalOpen}
                />
              </>
            );
          }}
        </Formik>
        <div className="request-footer-wrapper">
          <div id="request-footer-content" className="request-footer-content-2">
            <BottomLine />
          </div>
        </div>
      </>
    );
  }
}

GetMailingAddress.propTypes = {
  initialReducer: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string,
  }).isRequired,
  country: PropTypes.string.isRequired,
  info: PropTypes.shape({
    firstName: PropTypes.string,
    middleInitial: PropTypes.string,
    lastName: PropTypes.string,
    dateOfBirth: PropTypes.string,
    phone: PropTypes.string,
    emailAddress: PropTypes.string,
    ssn: PropTypes.string,
    vin: PropTypes.string,
    reportType: PropTypes.string,
    reportTypeLabel: PropTypes.string,
  }),
  mailingAddress: PropTypes.object,
  suggestedMailingAddress: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number, // For cases like `400`
  ]),
  stateSelector: PropTypes.shape({
    currentStateResidence: PropTypes.string,
    customerRelation: PropTypes.string,
    brandAffiliation: PropTypes.string,
    bentleyCustomer: PropTypes.string,
  }).isRequired,
  requestSelector: PropTypes.object,
  selectedRequest: PropTypes.string.isRequired,
  networkError: PropTypes.object,
  customerRelation: PropTypes.string,
  secureKey: PropTypes.shape({
    givenName: PropTypes.string,
    middleName: PropTypes.string,
    familyName: PropTypes.string,
    birthDate: PropTypes.string,
    comSecurekeyVerifiedMeLicenseId: PropTypes.string,
    comSecurekeyVidsJobId: PropTypes.string,
  }),
  experianReducer: PropTypes.shape({
    submitPrivacyRequestPayload: PropTypes.shape({
      requester: PropTypes.shape({
        firstName: PropTypes.string,
        middleName: PropTypes.string,
        lastName: PropTypes.string,
        dateOfBirth: PropTypes.string,
        phone: PropTypes.string,
        emailAddress: PropTypes.string,
        fullSsn: PropTypes.string,
        vin: PropTypes.string,
        addresses: PropTypes.arrayOf(
          PropTypes.shape({
            addressLine1: PropTypes.string,
            city: PropTypes.string,
            stateOrProvince: PropTypes.string,
            postalCode: PropTypes.string,
          })
        ),
      }),
      requestType: PropTypes.string,
    }),
  }),
  updateMailingAddress: PropTypes.func.isRequired,
  getAddressValidation: PropTypes.func.isRequired,
  submitPrivacyRequest: PropTypes.func.isRequired,
  getExperianDetails: PropTypes.func.isRequired,
  getProtectionServicesExperianDetails: PropTypes.func.isRequired,
  submitInfo: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  initialReducer: state.initialReducer,
  country: state.initialReducer.country,
  info: state.info,
  mailingAddress: state.mailingAddress,
  suggestedMailingAddress: state.suggestedMailingAddress,
  stateSelector: state.stateSelector,
  requestSelector: state.requestSelector,
  selectedRequest: state.requestSelector.selectedRequest,
  networkError: state.networkError,
  customerRelation: state.stateSelector.customerRelation,
  secureKey: state.secureKey,
  experianReducer: state.getProtectionServicesExperianReducer,
});

const mapDispatchToProps = (dispatch) => ({
  updateMailingAddress: (values) =>
    dispatch({ type: T.MAILING_ADDRESS_REQUESTED, payload: values }),
  getAddressValidation: (action, modalProps, historyProps) =>
    dispatch(getAddressValidation(action, modalProps, historyProps)),
  submitPrivacyRequest: (action, routeProps, historyProps) =>
    dispatch(submitPrivacyRequest(action, routeProps, historyProps)),
  getExperianDetails: (action, routeProps, submitPrivacyRequestPayload) =>
    dispatch(
      getExperianDetails(action, routeProps, submitPrivacyRequestPayload)
    ),
  getProtectionServicesExperianDetails: (
    action,
    routeProps,
    submitPrivacyRequestPayload
  ) =>
    dispatch(
      getProtectionServicesExperianDetails(
        action,
        routeProps,
        submitPrivacyRequestPayload
      )
    ),
  submitInfo: (values) => dispatch({ type: "INFO_ENTERED", payload: values }),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GetMailingAddress));
